<template>
  <!-- 设备参数设置 -->
  <div id="eqConfig">
    <div style="text-align: left;!important">
      <span style="color: #dd514c;font-weight: bolder">
        {{$t("equipmentmanagement.currentMachineModel")}}：{{initValue.equipmentTypeName}}，{{$t("equipmentName")}}：{{ initValue.name }}，{{$t("equipmentNo")}}：{{ initValue.number }}
      </span>
    </div>
    <el-tabs v-model="activeName" @tab-click="tabsHandleClick">
      <el-tab-pane :label="$t('equipmentmanagement.functionSetting')" name="gnsz" v-if="gnsz" :lazy="true" >
        <div>
          <EquipmentParam v-if="tabName=='gnsz'" :initValue='equpid' @cancelData="cancelData()" ></EquipmentParam>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('equipmentmanagement.commonKeySetting')" name="ptaj" v-if="ptaj" :lazy="true">
        <div>
          <KeyConfigParam v-if="tabName=='ptaj'" :initValue="equpid"></KeyConfigParam>
        </div>
      </el-tab-pane>
      <el-tab-pane label="茶仓管理" name="ccgl" :lazy="true">
        <div>
          <tea-storage-maintain :initValue="equpid"></tea-storage-maintain>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('equipmentmanagement.priceSetting')" name="jgsz" v-if="jgsz" :lazy="true">
        <div>
          <EquipmentPriceSetting v-if="equpid&&tabName == 'jgsz'" :initvalue="equpid" ref="priceset"></EquipmentPriceSetting>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      width="40%"
      :title="$t('equipmentmanagement.selectTemplate')"
      :visible.sync="templateVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <!-- 查看模板卡片 -->
      <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
        <div v-for="(item,index) in ConfigTemplatesList" :key="index">
          <div style="margin-bottom:20px"><span style="font-weight:bold">{{$t('equipmentmanagement.templateName')}}： </span></div>
          <el-tag @click="loadTemplateList(item.id,true)" :class="bgFlag == true?'bgcolor':''">{{item.name}}</el-tag>
        </div>

      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="addTemplateToPram">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import EquipmentPriceSetting from '../equipmentmanagement/equipmentPriceSetting'
  import EquipmentPowderCheck from "../equipmentmanagement/EquipmentPowderCheck";
  import EquipmentParam from "./EquipmentParam";
  import KeyConfigParam from "./KeyConfigParam";
  import TeaStorageMaintain from "@/pages/equipmentmanagement/teaStorageMaintain.vue";


  export default {
    components: {
      EquipmentPriceSetting,EquipmentPowderCheck,EquipmentParam,KeyConfigParam,TeaStorageMaintain },
    props:
      ['initValue']
    ,
    data(){
      return {
        reloading:[],
        // mock数据
        configColumns:[],//数据
        // mock结束
        activeName: 'gnsz',
        pageSize:10,
        pageIndex:1,
        templateVisible:false,
        bgFlag:false,
        list:[],
        btnList:[],
        equpid:null,
        EquConfigList:[],
        langFlag:0,//语言选择0中文1英文
        totaltemplatesInfoCount:0,
        active: 0,
        ConfigTemplatesList:[],
        templatesInfoList:[],
        equipmentTypePage:[],
        totalConfigTemplatesCount:0,
        templateId:0,
        btnid:0,
        Btnsort:0,
        price:0,
        englishName:'',
        drinkName:'',
        keyconfig:0,
        tabName:'gnsz',
        gnsz:false,
        sjtj:false,
        ylxz:false,
        jgsz:false,
        yljz:false,
        ptaj:false,
        xmj:false,
        sbtpksz:false,
        sbspsz:false,
        disabled: false,
        checked:false,// 是否全选
        picData:[],
        checkModel:[],
        picPageSize:2,
        picCurrentListPage:1,
        picTotalCount:0,
        picPageIndex:0,
        isAdmin:false
      }
    },
    watch:{
      initValue(val, oldVal){//监听设备选择
        if(val!=oldVal){
          this.equpid = this.initValue;
          // this.loadEquipConfigList();
        }
      },
      checkModel(){
        if((this.checkModel.length == this.picData.length) && !(this.checkModel.length==0 && this.picData.length==0)){
          this.checked = true
        }else{
          this.checked = false
        }
      }
    },
    mounted() {
      this.equpid = this.initValue;
      console.log("初始化",this.initValue)

      this.getTypePages();
      this.isAdmin = this.$account.data.isAdmin
    },
    methods:{
      //取消保存操作，并关闭父dialog
      cancelData(){
        this.$emit('closeEqDialog')
      },
      // tabs标签页切换事件
      tabsHandleClick(tab, event) {
          switch(tab.name){
            case "sjtj":
              this.tabName = tab.name
              this.$refs.cupstatic;
              break;
            case "gnsz":
              this.tabName = tab.name
              //this.loadEquipConfigList();
              break;
            case "ptaj":
              this.tabName = tab.name
              //this.loadBtnConfigList();
              break;
            case "ylxz":
              this.tabName = tab.name;
              this.$refs.equpcon;
              break;
            case "jgsz":
              this.tabName = tab.name
              this.$refs.priceset;
              break;
            case "yljz":
              this.tabName = tab.name
              this.$refs.powderset;
              break;
            case "xmj":
              this.tabName = tab.name
              this.$refs.xmmachine;
            case "sbtpksz":
              this.tabName = tab.name
              this.queryPictureLibraryList(1)
            case "sbspsz":
              this.tabName = tab.name

          }
      },
      //获取类型页面
      getTypePages(){
        let that = this;
        this.$httpservice.get("api/Equipment/EquipmentType?id="+that.equpid.equipmentTypeId).then(
            function (data) {
                if(data.body.code=="200"){
                  that.activeName = data.body.data.equipmentTypePages[0].code;
                  that.tabName = data.body.data.equipmentTypePages[0].code;
                  that.$forceUpdate();
                  data.body.data.equipmentTypePages.forEach(e=>{
                    // that.equipmentTypePage.push(e.code)
                    if(e.code == 'sjtj'){
                      that.sjtj = true
                    }else if(e.code == 'ylxz'){
                      that.ylxz = true
                    }else if(e.code == 'jgsz'){
                      that.jgsz = true
                    }else if(e.code == 'yljz'){
                      that.yljz = true
                    }else if(e.code == 'gnsz'){
                      that.gnsz = true
                    }else if(e.code == 'ptaj'){
                      that.ptaj = true
                    }else if(e.code == 'xmj'){
                      that.xmj = true
                    }else if(e.code == 'sbtpksz'){
                      that.sbtpksz = true
                    }else if(e.code == 'sbspsz'){
                      that.sbspsz = true
                    }
                  })
                }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                  message: that.$t('queryFailedStatusCode')+statusCode,
                  type: 'warning'
              });
            }
        );
      },

      //获取模板信息
      chooseTemplate(){
        this.bgFlag = false;
        this.templateVisible = true;
        let param = {
          pageIndex:this.pageIndex,
          pageSize:this.pageSize,
        };
        let that = this;
        this.$httpservice.get("api/Equipment/GetEquipmentConfigTemplates",param).then(
          function (data) {
            if(data.body.code=="200"){
              that.ConfigTemplatesList = data.body.data;
              that.totalConfigTemplatesCount = data.body.totalCount;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      //根据id加载模板信息
      loadTemplateList(id,flag){
        this.bgFlag = flag;
        this.templateId = id;
        let that = this;
        this.$httpservice.get("api/Equipment/GetEquipmentConfigTemplate?equipmentConfigTemplateId="+id).then(
          function (data) {
            if(data.body.code=="200"){
              that.templatesInfoList = data.body.data;
              that.totaltemplatesInfoCount = data.body.totalCount;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      //将模板应用到设备
      addTemplateToPram(){
        if(this.templateId == 0){
          that.$message({
            message: that.$t('stc.pleaseSelectTemplate'),
            type: 'danger'
          });
        }else{
          let that = this;
          this.$httpservice.get("api/Equipment/ApplyConfigTemplateParametersToEquipment?equipmentId="+that.equpid.id+"&templateId="+that.templateId).then(
            function (data) {
              if(data.body.code=="200"){
                that.$message({
                  message: data.body.msg,
                  type: 'success'
                });
                this.templateVisible = false;
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
        }
      },
      // 工具方法
      delArrayItem(array,item){
        const index = array.indexOf(item)
        if(index >-1){
          array.splice(index,1)
        }
      },
      checkArrayItem(array,item){
        const index = array.indexOf(item)
        if(index!=-1){
          return
        }else{
          array.push(item)
        }
      },
      // 重置输入框样式
      resetInputStyle(){
        let dom = document.querySelectorAll('.inputMaybeChange>input')
        for(let item in dom){
          if(dom[item].style){
            dom[item].style.backgroundColor = '#ffffff'
          }
        }
      },
      // 获取该设备和用户的图片库
      queryPictureLibraryList(pageIndex){
        let that = this
        // 清空图片库
        this.picData = []
        this.checkModel = []
        if(this.initValue && this.initValue.dtuNumber){
          let param = {
            dtuNo:this.initValue.dtuNumber
          }
          this.$httpservice.get('api/Equipment/GetPictures', param).then(result => {
            if(result.status == 200){
              let pics = result.body.data
              pics.forEach(item=>{
                let obj = new Object()
                obj.picture = item
                obj.picture_Id = item.id
                this.picData.push(obj)
              })
            }
          })
        }else{
          this.$message.error(that.$t('equipmentmanagement.equipmentInformationAcquisitionAbnormal'))
          return
        }
      },
      // 单选图片
      checkedOnePic(id){
        let index = this.checkModel.indexOf(id)
        if(index == -1){
          this.checkModel.push(id)
        }else{
          this.checkModel.splice(index,1)
        }
      },
      // 选择图片
      chooseLibraryPic(e){
        let that = this
        if(e){
          // 如果已经存在相同ID，就不允许新增
          let index = this.picData.findIndex(item=>item.picture_Id == e.id)
          if(index == -1){
            let obj = new Object()
            obj.picture = e
            obj.picture_Id = e.id
            this.picData.push(obj)
          }else{
            this.$message.error(that.$t('equipmentmanagement.thisImageHasBeenSelected'))
            return
          }
        }
      },
      // 全选图片库图片
      checkAllPictureLibrary(){
        let that = this
        if(this.checked){
          this.checkModel = []
        }else{
          if(this.picData.length==0){
            this.$message.error(that.$t('notSelectedImage'))
            return
          }
          this.picData.forEach(item=>{
            if(this.checkModel.indexOf(item.picture_Id)==-1){
              this.checkModel.push(item.picture_Id)
            }
          })
        }
      },
      // 保存图片库
      savePictureLibrary(){
        let that = this
        // 获取该设备的ID
        if(this.initValue && this.initValue.id){
          let pictureIds = []
          this.picData.forEach(item=>{
            pictureIds.push(item.picture_Id)
          })
          this.$httpservice.post('api/Equipment/BindPictures?equipmentId='+this.initValue.id,pictureIds).then(res=>{
            if(res.status==200){
              this.$message.success(that.$t('equipmentmanagement.imageLibrarySavedSuccessfully'))
            }else{
              this.$message.error(that.$t('equipmentmanagement.imageLibrarySavedUnSuccessfully'))
            }
            this.queryPictureLibraryList(1)
          })
        }else{
          this.$message.error(that.$t('equipmentmanagement.equipmentInformationAcquisitionFailed'))
          return
        }
      },
      // 删除图片
      deletePictureLibrary(){
        let that = this
        // 如果什么都没选择，提示不允许
        if(this.checkModel.length==0){
          this.$message.error(this.$t('equipmentmanagement.pleaseSelectTheImageToBeDeleted'))
          return
        }
        let ids =[]
        // 删除就页面删除
        this.checkModel.forEach((item,index)=>{
          let picDataIndex = this.picData.findIndex(item2=>item2.picture_Id == item)
          // 如果找到了就删除
          if(picDataIndex>=0){
            this.picData.splice(picDataIndex,1)
            // 如果找到了，还要删掉已选中里的值
            // this.checkModel.splice(index,1)
            ids.push(item)
          }
        })
        ids.forEach(item=>{
          let index = this.checkModel.indexOf(item)
          if(index >= 0 ){
            this.checkModel.splice(index,1)
          }
        })
      },
      handleCurrentChange(e) {
        this.pageIndex = e;
        this.currentlistpage = e
        this.queryPictureLibraryList(e)
      },
    }
  }
</script>

<style scoped lang="less">
  #eqConfig{
    input{
      text-align: center!important;
    }
    .forDiv{
      .el-col{
        height: 1px;
      }
    }
    .bottom-div{
      .el-col{
        text-align: center;
      }
    }
    .el-select{
      width: 100%
    }
    .eqConfig-2s-div{
      .el-row{
        margin: 0!important;
      }
      .el-divider--horizontal{
        margin: 0 auto;
        width: 95%;
      }
      .el-divider{
        background-color:#8B4513;
      }
    }
    .eqConfig-1f-div{
      line-height: 60px;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
  .el-upload{
    border:2px solid #303133!important;
  }
  .chooseMb{
    position: relative;
  }
  .editDiaInput{
    width: 30%;
    margin: 0 0 0 0px;
  }
  .item {
    // margin-top: 10px;
    margin-right: 20px;
  }
  .bgcolor {
    background-color: #113874;
    border: 0;
    outline: none;
    color: white;
  }
  .btnclass{
    display:inline-block;
    position: relative;
    vertical-align: middle;
    margin-top:10px
  }
  .btnclass-right{
    display: inline-block;
    position: absolute;
    vertical-align: middle;
    /* float: right; */
    right: 10px;
    margin-top: 10px;
    z-index: 9;
    }
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/equipPramConfig.vue